import { create } from 'zustand';
import { 
  AgendamentoState, 
  AgendamentoStep, 
  UnidadeDto, 
  ServicoDto, 
  ProfissionalDto 
} from '../agendamento.types';
import { ThemeType } from '../temas/temas-config-ts';

interface AgendamentoActions {
  // Navegação
  setStep: (step: AgendamentoStep) => void;
  nextStep: () => void;
  prevStep: () => void;
  
  // Seleção de Dados
  setUnidade: (unidade: UnidadeDto) => void;
  setServico: (servico: ServicoDto) => void;
  setHorario: (data: string, hora: string) => void;
  setProfissional: (p: ProfissionalDto) => void;
  
  // Gestão de Dados de Cache/Tema
  setProfissionaisDisponiveis: (lista: ProfissionalDto[]) => void;
  setTema: (tema: ThemeType) => void;
  
  // Controle Global
  reset: () => void;
}

const initialState: AgendamentoState = {
  step: AgendamentoStep.SERVICOS,
  unidade: undefined,
  servico: undefined,
  data: undefined,
  horario: undefined,
  profissional: undefined,
  profissionaisDisponiveis: [],
  tema: 'MODERNO_BLUE',
};

export const useAgendamentoStore = create<AgendamentoState & AgendamentoActions>((set) => ({
  ...initialState,

  /* --- NAVEGAÇÃO --- */
  setStep: (step) => set({ step }),

  nextStep: () => set((state) => ({ 
    step: state.step + 1 
  })),
  
  prevStep: () => set((state) => ({ 
    step: Math.max(AgendamentoStep.SERVICOS, state.step - 1) 
  })),

  /* --- SELEÇÃO DE ENTIDADES --- */
  setUnidade: (unidade) => set({ 
    unidade,
    // Define o tema da unidade se existir, senão mantém o default
    tema: (unidade as any)?.temaConfig || 'MODERNO_BLUE'
  }),
  
  setServico: (servico) => set({ 
    servico, 
    step: AgendamentoStep.HORARIOS 
  }),

  setHorario: (data, hora) => set({ 
    data, 
    horario: hora, 
    step: AgendamentoStep.PROFISSIONAIS 
  }),

  setProfissional: (p) => set({ 
    profissional: p, 
    step: AgendamentoStep.RESUMO 
  }),

  /* --- CACHE E TEMA --- */
  setProfissionaisDisponiveis: (lista) => set({ 
    profissionaisDisponiveis: lista 
  }),

  setTema: (tema) => set({ tema }),

  /* --- RESET --- */
  reset: () => {set(initialState)},
}));